import { saveAs } from "file-saver";

/**
 * Extracts the prescription ID from a URL.
 * @param {string} url - The URL to parse. Expected format: '/prescriptions/{id}'
 * @returns {number|null} The prescription ID or null if the URL doesn't match the expected format
 */
export const toUrlName = (url) => {
  const match = url.match(/\/prescriptions\/(\d+)/);
  return match ? parseInt(match[1]) : null;
};

export const fetchPdfBlob = async (url) => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch PDF. HTTP status: ${response.status}`);
  }
  return response.blob();
};

const saveBlobAsPdf = (blob, id) => {
  saveAs(blob, `${id}.pdf`);
};

export const downloadPdf = async (url, id) => {
  const response = await fetch(`${url}&download=true`);
  if (!response.ok) {
    throw new Error(`Failed to fetch PDF. HTTP status: ${response.status}`);
  }
  const blob = await response.blob();
  saveBlobAsPdf(blob, id);
};
